import { UntypedFormGroup } from '@angular/forms';
import { DepositFormFiller } from './form-filler.factory';
import { UserFullInfo } from 'src/app/services/auth/login/login.models';

export class Interkassa implements DepositFormFiller {
    public fillForm(form: UntypedFormGroup, userInfo: UserFullInfo) {
        console.log("interkass form filler")
        const date = new Date();
        const offset = date.getTimezoneOffset();
        const timezone = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;
        form.get('ik_x_browser_screen_height').setValue(screen.height);
        form.get('ik_x_browser_screen_width').setValue(screen.width);
        form.get('ik_x_browser_color_depth').setValue(screen.colorDepth);
        form.get('ik_x_browser_java_enabled').setValue(true)
        form.get('ik_x_browser_language').setValue(navigator.language)
        form.get('ik_x_browser_time_zone').setValue(timezone)
        form.get('ik_x_browser_time_zone_offset').setValue(offset)
        form.get('ik_x_browser_user_agent').setValue(navigator.userAgent)
        return
    }
}
